import { getFragmentData, graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { BulkClassRoomCreationRequestFragment } from "./BulkClassRoomCreationRequestFragment.ts";
import { type BulkClassRoomCreationRequestGraphqlDto } from "../gql/graphql.ts";

const GetAllBulkClassRoomCreationRequestsQuery = graphql(`
  query getAllBulkClassRoomCreationRequests {
    getAllBulkClassRoomCreationRequests {
      ...BulkClassRoomCreationRequest
    }
  }
`);

export function useGetAllBulkClassRoomCreationRequests() {
  const { data, loading, error, refetch } = useQuery(
    GetAllBulkClassRoomCreationRequestsQuery,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    requests: (getFragmentData(
      BulkClassRoomCreationRequestFragment,
      data?.getAllBulkClassRoomCreationRequests,
    ) ?? []) as BulkClassRoomCreationRequestGraphqlDto[],
    loading,
    error,
    refetch,
  };
}
